import {Injectable, signal} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {catchError, EMPTY, map, Observable} from 'rxjs';
import {LoadingSpinnerService} from './loading-spinner.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly _authenticated = signal(false);
  private readonly _ongoingLogout = signal(false);
  readonly authenticated = this._authenticated.asReadonly();
  readonly ongoingLogout = this._ongoingLogout.asReadonly();


  constructor(
    private readonly httpClient: HttpClient,
    private readonly loadingService: LoadingSpinnerService) {
  }

  public redirectToLogin() {
    window.location.href = environment.backendUrl + "/login";
  }

  public refreshToken(): Observable<HttpResponse<any>> {
    return this.httpClient.get<HttpResponse<any>>(environment.backendUrl + "/token/refresh", {
      withCredentials: true,
      observe: 'response'
    });
  }

  /**
   * Logs out the user and redirects to the landing page.
   */
  public logout(): void;
  /**
   * Logs out the user and redirects to the landing page with the given exception subject and body shown in the exception modal.
   * @param exceptionSubject The subject of the exception to be shown in the exception modal.
   * @param exceptionBody The body of the exception to be shown in the exception modal.
   */
  public logout(exceptionSubject: string, exceptionBody: string): void;
  public logout(exceptionSubject?: string, exceptionBody?: string): void {
    this._ongoingLogout.set(true);
    this._authenticated.set(false);
    let exceptionUrlParams = "";
    this.loadingService.show();
    if (exceptionSubject && exceptionBody) {
      exceptionUrlParams = "?exceptionSubject=" + exceptionSubject + "&exceptionBody=" + exceptionBody;
    }
    window.location.href = environment.backendUrl + "/logout" + exceptionUrlParams;
  }

  public isAuthenticated(): boolean {
    return this.authenticated();
  }

  public authenticate(): Observable<boolean> {
    return this.httpClient.get<HttpResponse<any>>(environment.backendUrl + "/auth-check", {observe: 'response'})
      .pipe(
        map(
          response => {
            if (response.ok) {
              this._authenticated.set(true);
              return true;
            } else {
              this._authenticated.set(false);
              return false;
            }
          }),
        catchError(() => {
          return EMPTY;
        })
      );
  }

}
